<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="pa-4">
    <v-col cols="12" xs="12" sm="12" class="pt-0 py-0" v-if="showTitle">
      <span class="headline">Medien Verwaltung (global)</span>
    </v-col>
    <v-col cols="12" xs="12" class="pt-0 py-0 d-flex align-end">
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
          v-model="search"
          append-icon="search"
          label="Suche"
          single-line
          hide-details
      ></v-text-field>
    </v-col>
    <v-col cols="12" xs="12" v-if="mediaList">
      Einträge löschbar : <span style="color: gray">{{mediaList.length}}</span> von <span style="color: gray">{{cntAll}}</span>
      Gesamt: <span style="color: gray">{{toMB(storageInKbDeletable,2)}}</span> von <span style="color: gray">{{toMB(hdSizeUsed,2)}}</span>
    </v-col>
      <v-col cols="12" xs="12" v-if="completeData && selected.length > 0" align="start">
        <v-btn small @click="removeAllSelected(selected, false)">
          Auswahl löschen auf Storage
        </v-btn>
        <span v-if="cntChanged > 0" style="color:green; ">Verändert {{cntChanged}}</span>
      </v-col>
      <v-col cols="12" xs="12">

        <v-data-table
        :headers="headers"
        :items="mediaList"
        :search="search"
        v-model="selected"
        show-select
        fixed-header
        :height="tableHeight"
        hide-default-footer
        hide-details
        :items-per-page="-1"
        >
          <template v-slot:item.localFileName="{ item }">
            <v-img :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" contain alt="Thumbnail" max-height="80" max-width="80"></v-img>
            <span> {{item.localFileName}}</span>
          </template>

          <template v-slot:item.created="{ item }">
            <span> {{formatDateTime(item.created)}}</span>
          </template>
          <template v-slot:item.size="{ item }">
            <span> {{toMB(item.size,2)}}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-row>
              <v-col>
              <v-btn small @click="deleteItem(item)">
                <v-icon>delete</v-icon>
              </v-btn>
              </v-col>
              <v-col>
              </v-col>
            </v-row>
            <!--
            <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
            >
              edit
            </v-icon>
            <v-icon
                    small
                    @click="deleteItem(item)"
            >
              delete
            </v-icon>

            -->
          </template>
        </v-data-table>
      </v-col>

      <DialogLinkCompany ref="dlgLink" @save="onLinkCompany"></DialogLinkCompany>
      <DialogDeleteItem ref="dlgDelete" @doDelete="doDelete"></DialogDeleteItem>
      <v-dialog v-model="dialog">
        <v-card>
          <v-card-title class="headline">Aktiv Status setzen</v-card-title>
          <v-card-text>Das setzen des Status betrifft <span class="cntOver">{{cntItems}}</span> Media Items / Items</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="darken" @click="dialog = false">abbrechen</v-btn>
            <v-btn color="darken" @click="setStatusNow()">Status jetzt setzen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
</template>

<script>
import Vue from 'vue'
import DialogLinkCompany from './../module/dialogs/DialogLinkCompany'
import DialogDeleteItem from "../dialogs/DialogDeleteItem";
import moment from "moment";

var _ = require('lodash')
export default {
  name: 'TableGlobalMedien',
  props: {
    companyId: String,
    showTitle: Boolean,
    isCompanyView: Boolean
  },
  components: {DialogLinkCompany,DialogDeleteItem},
  methods: {

    resize: function () {
      this.tableHeight = window.innerHeight - 246;
      if (this.showTitle) {
        this.tableHeight = window.innerHeight - 246;
      }
      if (this.tableHeight < 150) {
        this.tableHeight = 150;
      }
    },
    deleteItem: function (item) {
      this.$refs.dlgDelete.open({
        type: 'Medium',
        id: '' + item.guid,
        name: 'Medium ' + item.name,
        item: item
      })
    },
    doDelete: function (item) {
      console.log('item', item)
      // Vue.prototype.$api.deleteDevice(item.item.guid, this.reload)
    },
    onChangeAll: function () {
      Vue.prototype.storage.saveState('deviceShowAll', this.showAll)
      this.reload()
    },
    editItem: function (item) {
      if (this.companyId) {
        this.$router.push('/Netzwerke/' + this.companyId + '/Geraete/' + item.guid)
      } else {
        this.$router.push('/Geraete/' + item.guid)
      }

    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: #aa4444;'
      }
      return style
    },
    removeAllSelected: function () {
      console.log('removeAllSelected', this.selected)
      Vue.prototype.$api.deleteMediaByStatus(this.selected, this.deleteDone)
    },
    deleteDone: function (response) {
      console.log('deleteDone', response)
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    reload: function () {
      Vue.prototype.$api.loadMediaStatus(this.onGetData)
    },
    reFilter: function () {
      let list = []
      for (var ii in this.completeData) {
        let item = this.completeData[ii]
        let found = false
        for (var index in item.tagArray) {
          let tag = item.tagArray[index]
          console.log('list', tag, this.filterTags)
          let fIndex = _.findIndex(this.filterTags, function (o) {
            return o === tag
          })
          if (fIndex > -1) {
            found = true
            break
          }
        }
        if (found) {
          list.push(item)
        }
      }
      console.log('list', list)
      this.mediaList = list
    },
    onGetData: function (result) {
      console.log('result', result)
      this.mediaList = result.deleteAbles
      this.cntAll = result.cntFilesInStorage
      this.hdSizeUsed = result.stats.storageInKb
      this.storageInKbDeletable = result.stats.storageInKbDeletable
      this.completeData = _.clone(this.mediaList)
    },
    onGetStatusList: function (data) {
      this.cntItems = data.cntMedia
      this.dialog = true
    },
    onGetStatusSet: function (data) {
      console.log('data', data)
      this.dialog = false
      this.reload()
    },
    setAll: function (item, state) {
      this.currentItem = item
      this.currentState = state
      Vue.prototype.$api.checkMediaStateFromCompany(this.companyId, item, state, this.onGetStatusList)
    },
    setAllSelected: function (arr, state) {
      let that = this
      this.currentState = state
      that.cntChanged = 0
      that.shouldChanged = arr.length
      let fnCheck = function (data) {
          console.log('data', data)
          that.cntChanged += 1
          if (that.cntChanged >= that.shouldChanged) {
              that.dialog = false
              that.reload()
          }
      }
      _.each(arr, function (item) {
        Vue.prototype.$api.setMediaStateFromCompany(that.companyId, item, that.currentState, fnCheck)
      })
    },
    setStatusNow: function () {
      Vue.prototype.$api.setMediaStateFromCompany(this.companyId, this.currentItem, this.currentState, this.onGetStatusSet)
    },
    formatDateTime: function (s) {
      return moment(s).format("DD.MM.YYYY HH:mm");
    },
  },
  data () {
    return {
      cntAll: 0,
      currentDevice: null,
      search: null,
      showAll: false,
      tableHeight: 100,
      dialog: false,
      hdSizeUsed: 0,
      storageInKbDeletable: 0,
      cntChanged: 0,
      cntItems: 0,
      selected: [],
      tags: [],
      filterTags: [],
      tableUtils: require('./TableUtils').default,
      headers: [
      ],
      mediaList: []
    }
  },
  mounted () {
     this.headers = [
      {text: 'Name', align: 'left', value: 'localFileName'},
       {text: 'Dateigröße', value: 'size'},
      {text: 'Erstellt', value: 'created'}
    ]
    var cmp = this
    this.$nextTick(() => {
      cmp.reload()
    })
    this.resize()
  },
  created() {
    Vue.prototype.$eventHub.$on('resize', this.resize)

  },
  destroyed() {
    Vue.prototype.$eventHub.$off('resize', this.resize)
  }
}
</script>

<style scoped>

  .cntOver {
    font-weight: bolder;
    font-size: 2em;
  }

</style>

<!--
        {text: 'Status', value: 'deviceState'},
        {text: 'Name', align: 'left', value: 'name'},
        /* {text: 'Android Id', align: 'left', value: 'androidId'}, */
        {text: 'Playlist', align: 'left', value: 'playlistName'},
        /*{text: 'Screen', value: 'screenNumber'},*/
        {text: 'Client Version', value: 'clientVersionString'},
        {text: 'Tags', value: 'tags'},
        {text: 'HD Kapazität', value: 'diskUsageCurrent'},
        /*{text: 'Erstellt', value: 'created'},*/
        {text: 'Letzte Rückmeldung', value: 'heartbeatDateTime'},
        /*{text: 'Remote', value: 'remoteAddress'},*/
        /*{text: 'Netzwerk', value: 'company'},*/
        {text: 'Kommentar', value: 'comment'},
        {text: 'Aktion', value: 'action'}

-->
